import { SECTION_PREFIX } from './constants';
import { createMap } from './createMap';
import { createOrganizationUnit } from './createOrganizationUnit';
import { processChildren } from './processChildren';
import {
  FormMap,
  Section,
} from '../../components/Manager/DatasetForm/types';

export const createFormItemsMap = (
  apiItems: any[],
  groups?: any[],
  sections?: any[]
) => {
  const sectionMap = createMap(sections || []);
  const groupMap = createMap(groups || []);
  const formItemsMap: FormMap = new Map();

  apiItems.forEach((item, index) => {
    // If the item has defined section
    if (item.section) {
      const foundSection = formItemsMap.get(SECTION_PREFIX + item.section) as
        | Section
        | undefined;

      // Verify if the section exists
      if (foundSection !== undefined) {
        processChildren(foundSection, item, index, groupMap);
        return;
      }

      // Section not found. Create new one.
      const section = sectionMap.get(item.section);

      if (section === undefined) {
        throw new Error(`Section ${item.section} not found`);
      }

      const newSection: Section = createOrganizationUnit(section, 'section');

      processChildren(newSection, item, index, groupMap);
      formItemsMap.set(SECTION_PREFIX + item.section, newSection);
      return;
    }

    // If the item has defined group
    processChildren(formItemsMap, item, index, groupMap);
    return;
  });

  return formItemsMap;
};
